import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import {
  BackendService,
  ApiService,
  SharedObjectBaseService,
  RequestOptionsArgs,
} from '@hub-components';
import { DiscoveriesResponse } from '../../models/discoveries-response.model';
import { Discovery, DiscoveryJson } from '../../models/discovery.model';

@Injectable({
  providedIn: 'root',
})
export class SharedDiscoveriesService extends SharedObjectBaseService {
  constructor(
    private backendService: BackendService,
    private apiService: ApiService,
  ) {
    super();
  }

  list(options: RequestOptionsArgs = {}): Observable<DiscoveriesResponse> {
    return this.backendService.load('/shared_discoveries', options)
      .pipe(
        map((res: { discoveries: DiscoveryJson[], discoveries_count: number }) => {
          return {
            discoveries: res.discoveries.map(d => new Discovery(d)),
            discoveriesCount: res.discoveries_count,
          };
        }),
      );
  }

  sharedObject(uuid) {
    return this.apiService
      .load(`/shared_objects/${uuid}`, { skipLoader: true, throwErrors: true });
  }

  create(discoveryId, permissions, invites, note, skip) {
    return this.backendService
      .create('/shared_discoveries', { share: { discovery_id: discoveryId, app: 'discoveries', note, skip, invites, dates: permissions.dates } });
  }

  update(shareUuid: string, payload: any) {
    return this.apiService
      .update(`/shared_objects/${shareUuid}`, { payload }, { skipLoader: true });
  }

  add(shareUuid, invites: any[], note, skip) {
    return this.backendService
      .create(`/shared_discoveries/${shareUuid}/invites`, { share: { invites, note, skip } });
  }

  remove(shareUuid, invite) {
    return this.backendService.delete(`/shared_discoveries/${shareUuid}/invites/${invite}`);
  }
}
